function dateTimeFormat(datetime) {
    if (!datetime) {
        return '';
    }

    return (new Date(datetime)).toLocaleString();
}

export {dateTimeFormat}